import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "stores/connect";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { getConfig } from "components/configurations/helpers";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { Button, Table } from "components/bootstrap";
import { IfPermitted, Spinner } from "components/common";
import GlobalProcessingView from "components/configurations/message-processors/GlobalProcessingView";
import ProcessingConfigModalForm from "./message-processors/ProcessingConfigModalForm";
const MessageProcessorsConfig = () => {
  const { t } = useTranslation("configurations");
  const [showConfigModal, setShowConfigModal] = useState(false);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  const [viewConfig, setViewConfig] = useState(void 0);
  const [formConfig, setFormConfig] = useState(void 0);
  useEffect(() => {
    Promise.all([
      ConfigurationsActions.listMessageProcessorsConfig(ConfigurationType.MESSAGE_PROCESSORS_CONFIG),
      ConfigurationsActions.list(ConfigurationType.GLOBAL_PROCESSING_RULE_CONFIG)
    ]).then(() => {
      const processorConfig = getConfig(ConfigurationType.MESSAGE_PROCESSORS_CONFIG, configuration);
      const globalConfig = getConfig(ConfigurationType.GLOBAL_PROCESSING_RULE_CONFIG, configuration);
      const config = {
        ...processorConfig,
        ...globalConfig,
        enableFutureTimestampNormalization: !!(globalConfig == null ? void 0 : globalConfig.grace_period)
      };
      setViewConfig(config);
      setFormConfig(config);
    });
  }, [configuration]);
  const openModal = () => {
    setShowConfigModal(true);
  };
  const closeModal = () => {
    setShowConfigModal(false);
    setFormConfig(viewConfig);
  };
  const isProcessorEnabled = (processor, config) => config.disabled_processors.filter((p) => p === processor.class_name).length < 1;
  const summary = () => {
    var _a;
    return (_a = viewConfig == null ? void 0 : viewConfig.processor_order) == null ? void 0 : _a.map((processor, idx) => {
      const status = isProcessorEnabled(processor, viewConfig) ? t("message_processors.status_active") : t("message_processors.status_disabled");
      return /* @__PURE__ */ React.createElement("tr", { key: processor.name }, /* @__PURE__ */ React.createElement("td", null, idx + 1), /* @__PURE__ */ React.createElement("td", null, processor.name), /* @__PURE__ */ React.createElement("td", null, status));
    });
  };
  if (!viewConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(GlobalProcessingView, { gracePeriod: viewConfig.grace_period }), /* @__PURE__ */ React.createElement("h2", null, t("message_processors.title")), /* @__PURE__ */ React.createElement("p", null, t("message_processors.description")), /* @__PURE__ */ React.createElement(Table, { bordered: true, condensed: true, className: "top-margin" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "#"), /* @__PURE__ */ React.createElement("th", null, t("message_processors.processor")), /* @__PURE__ */ React.createElement("th", null, t("message_processors.status")))), /* @__PURE__ */ React.createElement("tbody", null, summary())), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: openModal }, t("shared.edit_configuration"))), showConfigModal && /* @__PURE__ */ React.createElement(ProcessingConfigModalForm, { closeModal, formConfig }));
};
export default MessageProcessorsConfig;
